// AvailableUsersSaga.js

import { put, call, takeLatest } from "redux-saga/effects";
import * as api from "./userAPI";
import * as actionTypes from "../ActionTypes";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

function* availableUsersRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback } = action.payload || {};


    const response = yield call(api.getAvailableUsers);

    yield put({
      type: actionTypes.AVAILABLE_USERS_SUCCESS,
      payload: response,
    });

    if (typeof callback === "function") {
      callback({
        type: 1,
        data: response?.data?.[0]?.matchingUsers || [],
      });
    }
  } catch (err) {
    const message = err?.response?.data?.errors?.[0]?.message || err?.message;


    yield put({
      type: actionTypes.AVAILABLE_USERS_FAIL,
      payload: message,
    });

    if (typeof action.payload?.callback === "function") {
      action.payload.callback({ type: 0, error: message });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}
function* saveUserCircleRequestSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
  
    try {
      const { payload } = action;
      const { callback } = payload;
  
      const response = yield call(api.saveUserCircleAPI, payload);
  
      yield put({
        type: actionTypes.SAVE_USER_CIRCLE_SUCCESS,
        payload: response,
      });
  
      if (typeof callback === "function") {
        callback({ type: 1, data: response });
      }
    } catch (err) {
      const message = err?.response?.data?.errors?.[0]?.message || err.message;
  
      yield put({
        type: actionTypes.SAVE_USER_CIRCLE_FAIL,
        payload: message,
      });
  
      if (typeof action.payload?.callback === "function") {
        action.payload.callback({ type: 0, error: message });
      }
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }

  function* myCircleRequestsSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
  
    try {
      const { callback } = action.payload || {};
  
      const response = yield call(api.getMyCircleRequestsAPI, action.payload);
  
      yield put({
        type: actionTypes.MY_CIRCLE_REQUESTS_SUCCESS,
        payload: response,
      });
  
      callback?.({ type: 1, data: response.data });
    } catch (err) {
      const message =
        err?.response?.data?.errors?.[0]?.message || err.message;
  
      yield put({
        type: actionTypes.MY_CIRCLE_REQUESTS_FAIL,
        payload: message,
      });
  
      action.payload?.callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* updateUserCircleSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
  
    try {
      const { callback, ...apiPayload } = action.payload;
  
  
      const response = yield call(api.updateUserCircleAPI, apiPayload);
  
      yield put({
        type: actionTypes.UPDATE_USER_CIRCLE_SUCCESS,
        payload: response,
      });
  
      callback?.({ type: 1, data: response });
    } catch (err) {
      const message =
        err?.response?.data?.errors?.[0]?.message || err.message;
  
  
      yield put({
        type: actionTypes.UPDATE_USER_CIRCLE_FAIL,
        payload: message,
      });
  
      action.payload?.callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* myCircleListSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
  
    try {
      const { callback, ...payload } = action.payload || {};
  
  
      const response = yield call(api.getMyCircleAPI, payload);
  
      yield put({
        type: actionTypes.MY_CIRCLE_LIST_SUCCESS,
        payload: response,
      });
  
      callback?.({ type: 1, data: response.data });
    } catch (err) {
      const message =
        err?.response?.data?.errors?.[0]?.message || err.message;
  
  
      yield put({
        type: actionTypes.MY_CIRCLE_LIST_FAIL,
        payload: message,
      });
  
      action.payload?.callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  
  
export default function* AvailableUsersWatcherSaga() {
  yield takeLatest(
    actionTypes.AVAILABLE_USERS_REQUEST,
    availableUsersRequestSaga
  );
  yield takeLatest(
    actionTypes.SAVE_USER_CIRCLE_REQUEST,
    saveUserCircleRequestSaga
  );
  yield takeLatest(
    actionTypes.MY_CIRCLE_REQUESTS_REQUEST,
    myCircleRequestsSaga
  );
  yield takeLatest(
    actionTypes.UPDATE_USER_CIRCLE_REQUEST,
    updateUserCircleSaga
  );
  yield takeLatest(
    actionTypes.MY_CIRCLE_LIST_REQUEST,
    myCircleListSaga
  );
  
}
